import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { domHistory } from '@hum/common';
import './styles.pc';
import { Provider } from '../Provider';
import { storeApi, reduxStore } from '../store';
import { useApplyTheme, MaintenanceBanner } from '@hum/ui-library';
import { useFlags } from '@hum/icm-app/src/hooks/useFlags';
import { SessionController } from './SessionController';
import { Auth0Provider } from '@auth0/auth0-react';

const queryClient = new QueryClient();
let cookieDomain = '.localhost';
if (process.env.NODE_ENV === 'staging') {
  cookieDomain = '.humcapital.info';
} else if (process.env.NODE_ENV === 'production') {
  cookieDomain = '.humcapital.com';
}

const BannerContainer = () => {
  const flags = useFlags();
  const banner = flags.enabled('maintenance-banner')
    ? (flags.value('maintenance-banner') as Record<string, any>)
    : null;

  return flags.enabled('maintenance-banner') ? (
    <MaintenanceBanner title={banner?.title} message={banner?.message} />
  ) : null;
};

export const Main = () => {
  useApplyTheme();

  return (
    <Provider store={reduxStore} api={storeApi} history={domHistory}>
      <QueryClientProvider client={queryClient}>
        <Auth0Provider
          domain={process.env.AUTH0_DOMAIN || ''}
          clientId={process.env.AUTH0_CLIENT_ID || ''}
          authorizationParams={{
            audience: process.env.AUTH0_AUDIENCE || '',
          }}
          useRefreshTokensFallback
          useRefreshTokens
          cookieDomain={cookieDomain}
        >
          <BannerContainer />
          <SessionController />
        </Auth0Provider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  );
};
